export class Notification {
    assignment;
    editLink = '';
    message = '';
    user = {};
    users = [];

    constructor(notification: object) {
        this.setProperties(notification);
    }
    setProperties(args) {
        for(var i in args) {
            this[i] = args[i];
        }
    }
} 


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/shared/notification.model.ts